import React from "react";

export default function StateItem({ icon, value, label }) {
  return (
    <section className="flex flex-col items-center justify-start gap-1 px-0 md:flex-row md:justify-center md:gap-3 md:px-6 2xl:gap-4">
      <div>{icon}</div>
      <div>
        <p className="text-center font-manrope text-[15px] font-extrabold leading-tight text-[#333333] md:text-left md:text-[17px] 2xl:text-[20px]">
          {value}
        </p>

        <p className="text-center font-manrope text-[11px] font-semibold leading-tight text-[#666A7C] md:text-left md:text-[13px] 2xl:text-[14px]">
          {label}
        </p>
      </div>
    </section>
  );
}
